export enum MentionSearchType {
  ALL = 'all',
  PROJECT = 'project',
  ROADMAP = 'roadmap',
  STRATEGY_MAP = 'strategymap',
  EPIC = 'epic',
  FEATURE = 'feature',
  TEAM = 'team',
  RESOURCE = 'resource'
}

export interface MentionSearchParams {
  searchTerm: string;
  searchType: MentionSearchType;
  page: number;
  perPage: number;
}

export interface MentionSearchResponse {
  projects: any[];
  roadmaps: any[];
  teams: any[];
  resources: any[];
  total_projects: number;
  total_roadmaps: number;
  total_teams: number;
  total_resources: number;
  page: number;
  per_page: number;
  search_term: string;
  search_type: string;
}
